var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"occ-tag",class:[
    ("occ-tag__type--" + _vm.type),
    _vm.type === 'dot' && _vm.status ? ("occ-tag__type--dot--" + _vm.status) : '',
    _vm.color ? ("occ-tag__color--" + _vm.color) : '',
    _vm.clickable && "occ-tag--clickable"
  ],on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.label)?_c('span',{staticClass:"occ-tag__text",class:[
      ("occ-tag__text__type--" + _vm.type),
      _vm.color ? ("occ-tag__text__color--" + _vm.color) : '',
      _vm.bold ? 'occ-tag__text--bold' : '',
      _vm.align ? ("occ-tag__text__align--" + _vm.align) : ''
    ],style:({ 'font-size': _vm.size })},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),(_vm.deleteButton)?_c('svg-icon',{staticClass:"occ-tag__delete",attrs:{"name":"renewal/x","width":"12px"},on:{"click":function($event){$event.stopPropagation();return _vm.deleteEvent.apply(null, arguments)}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }